import React from 'react';
import dynamic from 'next/dynamic';

import { ProductPageTemplate } from 'src/templates';
import { ProductPageHeader } from 'src/components/headers/ProductPageHeader';
import Features from 'src/components/features';
import FooterExtension from 'src/components/footer-extension';

import { Locales } from 'src/lib/constants';

// data
import {
  productHeaderData,
  featuresData,
  interactiveData,
  footerExtensionData,
  metaData,
} from 'src/store/en-eu/products/balance';

const InteractiveData = dynamic(
  () => {
    return import('src/components/Surfaces/InteractiveData/InteractiveData');
  },
  {
    ssr: false,
  },
);

const EUProductBalance = ({ locale = Locales.EN_EU }) => {
  return (
    <ProductPageTemplate
      fields={{ components: [], ...metaData }}
      locale={locale}
    >
      <ProductPageHeader {...productHeaderData} />
      <Features {...featuresData} />
      <InteractiveData {...interactiveData} />
      <FooterExtension {...footerExtensionData} />
    </ProductPageTemplate>
  );
};

export default EUProductBalance;
